const files: any[] = [
      {
        fileName: 'Placeringsavtal Arbetskooperativ 2021',
        url: '/assets/ak/Placeringsavtal Arbetskooperativ 2021.docx',
        tenderingID: 2,
        isPlacementFile: true
      },
      {
        fileName: 'Socialt arbetskooperativ Skånes Kommuner - Ramavtal 2021 - Upphandlat',
        url: '/assets/ak/Socialt arbetskooperativ Skånes Kommuner - Ramavtal 2021 - Upphandlat.pdf',
        tenderingID: 2
      },
      {
        fileName: 'FFU Socialt arbetskooperativ 2021 Skånes Kommuner',
        url: '/assets/ak/FFU Socialt arbetskooperativ 2021 Skånes Kommuner.pdf',
        tenderingID: 2
      },
      {
        fileName: 'Placeringsavtal utanför ramavtal HVB Vuxna 2020',
        url: '/assets/hvb/Placeringsavtal-utanför-ramavtal-HVB-Vuxna-2020.docx',
        tenderingID: 11,
        hideFromSupplier: true
      },
      {
        fileName: 'Uppdragsavtal-utanför-ram Öppenvård',
        url: '/assets/oppenvard/Uppdragsavtal-utanför-ram Öppenvård.docx',
        tenderingID: 212,
        hideFromSupplier: true
      },
      {
        fileName: 'Uppdragsavtal-handledning-inom-IFO-VO-och-Skola-2019',
        url: '/assets/handledning/Uppdragsavtal-handledning-inom-IFO-VO-och-Skola-2019.docx',
        tenderingID: 244,
        isPlacementFile: true
      },
      {
        fileName: 'Utvärdering-av-handledning',
        url: '/assets/handledning/Utvärdering-av-handledning.docx',
        tenderingID: 244
      },
      {
        fileName: 'Ramavtal-Handledning-inom-IFO-VO-och-Skola-2019',
        url: '/assets/handledning/Ramavtal-Handledning-inom-IFO-VO-och-Skola-2019.pdf',
        tenderingID: 244
      },
      {
        fileName: 'FFU Handledning 2019',
        url: '/assets/handledning/FFU Handledning 2019.pdf',
        tenderingID: 244
      },
      {
        fileName: 'Placeringsavtal-vo-lss-2019',
        url: '/assets/lss/Placeringsavtal-vo-lss-2019.docx',
        tenderingID: 415,
        isPlacementFile: true
      },
      {
        fileName: 'Placeringsavtal-utanför-ramavtal-VO-LSS-2019',
        url: '/assets/lss/Placeringsavtal-utanför-ramavtal-VO-LSS-2019.docx',
        tenderingID: 415,
        hideFromSupplier: true
      },
      {
        fileName: 'Ramavtal-och-krav-på-tjänst-VO-LSS-2019',
        url: '/assets/lss/Ramavtal-och-krav-på-tjänst-VO-LSS-2019.pdf',
        tenderingID: 415
      },
      {
        fileName: 'FFU LSS 2019',
        url: '/assets/lss/FFU LSS 2019.pdf',
        tenderingID: 415
      },
      {
        fileName: 'Placeringsavtal-VO-Psykiatri-2019',
        url: '/assets/psyk/Placeringsavtal-VO-Psykiatri-2019.docx',
        tenderingID: 457,
        isPlacementFile: true
      },
      {
        fileName: 'Placeringsavtal-utanför-Ramavtal-VO-Psykiatri-2019',
        url: '/assets/psyk/Placeringsavtal-utanför-Ramavtal-VO-Psykiatri-2019.docx',
        tenderingID: 457,
        hideFromSupplier: true
      },
      {
        fileName: 'Ramavtal-och-krav-på-tjänst-VO-Psykiatri-2019',
        url: '/assets/psyk/Ramavtal-och-krav-på-tjänst-VO-Psykiatri-2019.pdf',
        tenderingID: 457
      },
      {
        fileName: 'FFU PSYK 2019',
        url: '/assets/psyk/FFU PSYK 2019.pdf',
        tenderingID: 457
      },
      {
        fileName: 'Placeringsavtal-VO-Särskilt-boende-2019',
        url: '/assets/sabo/Placeringsavtal-VO-Särskilt-boende-2019.docx',
        tenderingID: 498,
        isPlacementFile: true
      },
      {
        fileName: 'Placeringsavtal-utanför-ramavtal-VO-Särskilt-boende-2019',
        url: '/assets/sabo/Placeringsavtal-utanför-ramavtal-VO-Särskilt-boende-2019.docx',
        tenderingID: 498,
        hideFromSupplier: true
      },
      {
        fileName: 'Ramavtal-och-krav-på-tjänst-VO-Särskilt-boende-2019',
        url: '/assets/sabo/Ramavtal-och-krav-på-tjänst-VO-Särskilt-boende-2019.pdf',
        tenderingID: 498
      },
      {
        fileName: 'FFU SÄBO 2019',
        url: '/assets/sabo/FFU SÄBO 2019.pdf',
        tenderingID: 498
      },
      {
        fileName: 'Placeringsavtal-LSS-2022-Daglig-verksamhet',
        url: '/assets/lssdaglig/Placeringsavtal-LSS-2022-Daglig-verksamhet.docx',
        tenderingID: 787,
        isPlacementFile: true
      },
      {
        fileName: 'Placeringsavtal-utanför-ramavtal-LSS-daglig-verksamhet-2022',
        url: '/assets/lssdaglig/Placeringsavtal-utanför-ramavtal-LSS-daglig-verksamhet-2022.docx',
        tenderingID: 787,
        hideFromSupplier: true
      },
      {
        fileName: 'Ramavtal-och-krav-på-tjänst-daglig-verksamhet-2022',
        url: '/assets/lssdaglig/Ramavtal-och-krav-på-tjänst-daglig-verksamhet-2022.pdf',
        tenderingID: 787
      },
      {
        fileName: 'FFU-LSS-Daglig-verksamhet-2022',
        url: '/assets/lssdaglig/FFU-LSS-Daglig-verksamhet-2022.pdf',
        tenderingID: 787
      },
      {
        fileName: 'Placeringsavtal-LSS-2022-Bostad-med-särskild-service',
        url: '/assets/lssbostad/Placeringsavtal-LSS-2022-Bostad-med-särskild-service.docx',
        tenderingID: 803,
        isPlacementFile: true
      },
      {
        fileName: 'Placeringsavtal-utanför-ramavtal-LSS-bostad-2022',
        url: '/assets/lssbostad/Placeringsavtal-utanför-ramavtal-LSS-bostad-2022.docx',
        tenderingID: 803,
        hideFromSupplier: true
      },
      {
        fileName: 'Ramavtal-och-krav-på-tjänst-bostad-med-särskild-service-2022',
        url: '/assets/lssbostad/Ramavtal-och-krav-på-tjänst-bostad-med-särskild-service-2022.pdf',
        tenderingID: 803
      },
      {
        fileName: 'FFU-LSS-Bostad-med-särskild-service-2022',
        url: '/assets/lssbostad/FFU-LSS-Bostad-med-särskild-service-2022.pdf',
        tenderingID: 803
      },
      {
        fileName: 'FFU HVB barn och unga 2021, Skåne, Halland, Kronoberg',
        url: '/assets/hvb2021/FFU HVB barn och unga 2021, Skåne, Halland, Kronoberg.pdf',
        tenderingID: 531
      },
      {
        fileName: 'Placeringsavtal HVB Barn och unga 2021',
        url: '/assets/hvb2021/Placeringsavtal HVB Barn och unga 2021.docx',
        tenderingID: 531,
        isPlacementFile: true
      },
      {
        fileName: 'Ramavtal och krav på tjänst HVB barn och unga 2021, Skåne, Halland, Kronoberg',
        url: '/assets/hvb2021/Ramavtal och krav på tjänst HVB.pdf',
        tenderingID: 531
      },
      {
        fileName: 'Placeringsavtal utanför ramavtal HVB Barn och unga 2021',
        url: '/assets/hvb2021/Placeringsavtal-utanför-ramavtal-HVB-Barn-och-unga-2021.docx',
        tenderingID: 531,
        hideFromSupplier: true
      },
      {
        fileName: 'FFU Boende för personer med psykisk funktionsnedsättning 2022, Skåne, Halland, Kronoberg',
        url: '/assets/945/FFU Boende för personer med psykisk funktionsnedsättning 2022, Skåne, Halland, Kronoberg.pdf',
        tenderingID: 945
      },
      {
        fileName: 'Placeringsavtal utanför Ramavtal Boende för personer med psykisk funktionsnedsättning',
        url: '/assets/945/Placeringsavtal-utanför-Ramavtal-Boende för personer med psykisk funktionsnedsättning.docx',
        tenderingID: 945,
        hideFromSupplier: true
      },
      {
        fileName: 'Placeringsavtal - Boende för personer med psykisk funktionsnedsättning 2022',
        url: '/assets/945/Placeringsavtal - Boende för personer med psykisk funktionsnedsättning 2022.docx',
        tenderingID: 945,
        isPlacementFile: true
      },
      {
        fileName: 'Ramavtal Boende för personer med psykisk funktionsnedsättning 2022, Skåne, Halland, Kronoberg',
        url: '/assets/945/Ramavtal Boende för personer med psykisk funktionsnedsättning 2022, Skåne, Halland, Kronoberg.pdf',
        tenderingID: 945
      },
      {
        fileName: 'FFU Korttidsvistelse LSS 9.6, Skåne, Halland, Kronoberg',
        url: '/assets/983/FFU Korttidsvistelse LSS 9.6, Skåne, Halland, Kronoberg.pdf',
        tenderingID: 983
      },
      {
        fileName: 'Ramavtal och krav på tjänst Korttidsvistelse Skåne, Halland, Kronoberg 2023',
        url: '/assets/983/Ramavtal och krav på tjänst Korttidsvistelse Skåne, Halland, Kronoberg 2023.pdf',
        tenderingID: 983
      },
      {
        fileName: 'Placeringsavtal Korttidsvistelse LSS 9.6 2022',
        url: '/assets/983/Placeringsavtal Korttidsvistelse LSS 9.6 2022.docx',
        tenderingID: 983,
        isPlacementFile: true
      },
      {
        fileName: 'Placeringsavtal utanför ram Korttidsvistelse LSS 9.6 2022',
        url: '/assets/983/Placeringsavtal utanför ram Korttidsvistelse LSS 9.6 2022.docx',
        tenderingID: 983,
        hideFromSupplier: true
      },
      {
        fileName: 'FFU Särskilt Boende 2022 Skåne, Halland, Kronoberg',
        url: '/assets/990/FFU Särskilt Boende 2022 Skåne, Halland, Kronoberg.pdf',
        tenderingID: 990
      },
      {
        fileName: 'Ramavtal Särskilt Boende 2022, Skåne, Halland, Kronoberg',
        url: '/assets/990/Ramavtal Särskilt Boende 2022, Skåne, Halland, Kronoberg.pdf',
        tenderingID: 990
      },
      {
        fileName: 'Placeringsavtal- Särskilt boende 2022',
        url: '/assets/990/Placeringsavtal- Särskilt boende 2022.docx',
        tenderingID: 990,
        isPlacementFile: true
      },
      {
        fileName: 'Placeringsavtal-utanför-Ramavtal-Särskilt Boende',
        url: '/assets/990/Placeringsavtal-utanför-Ramavtal-Särskilt Boende.docx',
        tenderingID: 990,
        hideFromSupplier: true
      },
      {
        fileName: 'FFU Handledning inom IFO, VO och skola 2023',
        url: '/assets/1017/FFU Handledning inom IFO, VO och skola 2023.pdf',
        tenderingID: 1017
      },
      {
        fileName: 'Ramavtal Handledning inom IFO, VO och skola 2023',
        url: '/assets/1017/Ramavtal Handledning inom IFO, VO och skola 2023.pdf',
        tenderingID: 1017
      },
      {
        fileName: 'Uppdragsavtal handledning inom IFO, VO och skola 2023',
        url: '/assets/1017/Uppdragsavtal handledning inom IFO, VO och skola 2023.docx',
        tenderingID: 1017,
        isPlacementFile: true
      },
      {
        fileName: 'Utvärdering av handledning',
        url: '/assets/1017/Utvärdering av handledning.docx',
        tenderingID: 1017
      },
      {
        fileName: 'Placeringsavtal - HVB beroende vuxna 2024',
        url: '/assets/1386/Placeringsavtal - HVB beroende vuxna 2024.docx',
        tenderingID: 1386,
        isPlacementFile: true
      },
      {
        fileName: 'Ramavtal - HVB beroende vuxna 2024',
        url: '/assets/1386/Ramavtal - HVB beroende vuxna 2024.pdf',
        tenderingID: 1386
      },
      {
        fileName: 'Ramavtalsvillkor Krav på tjänsten HVB beroende vuxna 2024, Skåne, Halland, Kronoberg',
        url: '/assets/1386/Ramavtalsvillkor Krav på tjänsten HVB beroende vuxna 2024, Skåne, Halland, Kronoberg.pdf',
        tenderingID: 1386
      },
      {
        fileName: 'Upphandlingsdokumnt - HVB beroende vuxna 2024',
        url: '/assets/1386/Upphandlingsdokumnt - HVB beroende vuxna 2024.pdf',
        tenderingID: 1386
      },
      {
        fileName: 'Placeringsavtal-utanför-ramavtal-HVB-Vuxna-2024',
        url: '/assets/1386/Placeringsavtal-utanför-ramavtal-HVB-Vuxna-2024.docx',
        tenderingID: 1386,
        hideFromSupplier: true
      },
      {
        fileName: 'Uppdragsavtal delområde A1-A3 2024',
        url: '/assets/1463/Uppdragsavtal delområde A1-A3 2024.docx',
        tenderingID: 1463,
        isPlacementFile: true
      },
      {
        fileName: 'Uppdragsavtal delområde B1-B3 2024',
        url: '/assets/1463/Uppdragsavtal delområde B1-B3 2024.docx',
        tenderingID: 1463,
        isPlacementFile: true
      },
      {
        fileName: 'Förlängning av uppdragsavtal delområde B1 och B2 2024',
        url: '/assets/1463/Förlängning av uppdragsavtal delområde B1 och B2 2024.docx',
        tenderingID: 1463
      },
      {
        fileName: 'Uppdragsavtal delområde C1 2024',
        url: '/assets/1463/Uppdragsavtal delområde C1 2024.docx',
        tenderingID: 1463,
        isPlacementFile: true
      },
      {
        fileName: 'Familjehems- och jourhemsavtal delområde A1-A3 2024',
        url: '/assets/1463/Familjehems- och jourhemsavtal delområde A1-A3 2024.docx',
        tenderingID: 1463
      },
      {
        fileName: 'Familjehems- och jourhemsavtal delområde B1-B3 2024',
        url: '/assets/1463/Familjehems- och jourhemsavtal delområde B1-B3 2024.docx',
        tenderingID: 1463
      },
      {
        fileName: 'Ramavtal och krav på tjänst. Konsulentstöd till familjehem, jourhem 2024',
        url: '/assets/1463/Ramavtal och krav på tjänst. Konsulentstöd till familjehem, jourhem 2024.pdf',
        tenderingID: 1463
      },
      {
        fileName: 'Upphandlingsdokument. Konsulentstöd till familjehem, jourhem 2024',
        url: '/assets/1463/Upphandlingsdokument. Konsulentstöd till familjehem, jourhem 2024.pdf',
        tenderingID: 1463
      },
      {
        fileName: 'Månadsrapport Konsulentstöd 2024',
        url: '/assets/1463/Månadsrapport Konsulentstöd 2024.docx',
        tenderingID: 1463
      },
      {
        fileName: 'Obligatorisk checklista förhandsbedömning 2024',
        url: '/assets/1463/Obligatorisk checklista förhandsbedömning 2024.docx',
        tenderingID: 1463
      },
      {
        fileName: 'Uppdragsavtal Öppenvård 2024',
        url: '/assets/1515/Uppdragsavtal Öppenvård 2024.docx',
        tenderingID: 1515,
        isPlacementFile: true
      },
      {
        fileName: 'Uppdragsavtal-utanför-ram Öppenvård',
        url: '/assets/1515/Uppdragsavtal-utanför-ram Öppenvård.docx',
        tenderingID: 1515,
        hideFromSupplier: true
      },
      {
        fileName: 'Upphandlingsdokument Öppenvård 2024',
        url: '/assets/1515/Upphandlingsdokument Öppenvård 2024.pdf',
        tenderingID: 1515
      },
      {
        fileName: 'Ramavtal och krav på tjänsten. Öppenvård 2024, Skåne, Halland, Kronoberg',
        url: '/assets/1515/Ramavtal och krav på tjänsten. Öppenvård 2024, Skåne, Halland, Kronoberg.pdf',
        tenderingID: 1515
      },
      {
        fileName: 'Placeringsavtal Socialt boende med stöd för vuxna (från 21 år)',
        url: '/assets/1560/Placeringsavtal Socialt boende med stöd för vuxna (från 21 år).docx',
        tenderingID: 1560,
        isPlacementFile: true
      },
      {
        fileName: 'Ramavtal av krav på tjänst Socialt boende med stöd för vuxna (från 21 år)',
        url: '/assets/1560/Ramavtal av krav på tjänst Socialt boende med stöd för vuxna (från 21 år).pdf',
        tenderingID: 1560
      },
      {
        fileName: 'Upphandlingsdokument Socialt boende med stöd för vuxna (från 21 år) 2024',
        url: '/assets/1560/Upphandlingsdokument Socialt boende med stöd för vuxna (från 21 år) 2024.pdf',
        tenderingID: 1560
      },
      {
        fileName: 'Placeringsavtal utanför ramavtal Socialt boende med stöd för vuxna (från 21år)',
        url: '/assets/1560/Placeringsavtal utanför ramavtal Socialt boende med stöd för vuxna (från 21år).docx',
        tenderingID: 1560,
        hideFromSupplier: true
      },
      {
        fileName: 'Placeringsavtal Socialt arbetskooperativ för vuxna 2025',
        url: '/assets/1599/Placeringsavtal Socialt arbetskooperativ för vuxna 2025.docx',
        tenderingID: 1599,
        isPlacementFile: true
      },
      {
        fileName: 'Upphandlingsdokument. Socialt arbetskooperativ för vuxna 2025',
        url: '/assets/1599/Upphandlingsdokument. Socialt arbetskooperativ för vuxna 2025.pdf',
        tenderingID: 1599
      },
      {
        fileName: 'Ramavtal och krav på tjänst. Socialt arbetskooperativ för vuxna 2025',
        url: '/assets/1599/Ramavtal och krav på tjänst. Socialt arbetskooperativ för vuxna 2025.pdf',
        tenderingID: 1599
      },
      {
        fileName: 'Placeringsavtal LSS 9§8 Bostad barn och ungdomar 2026',
        url: '/assets/1606/Placeringsavtal LSS 9§8 Bostad barn och ungdomar 2026.docx',
        tenderingID: 1606,
        isPlacementFile: true
      },
      {
        fileName: 'Information om nytt ramavtal; LSS 9§8 Bostad barn och ungdomar 2026',
        url: '/assets/1606/Information om nytt ramavtal; LSS 9§8 Bostad barn och ungdomar 2026 (1).pdf',
        tenderingID: 1606
      },
      {
        fileName: 'Placeringsavtal utanför ram LSS 9§8 Bostad barn och ungdomar 2026',
        url: '/assets/1606/Placeringsavtal utanför ram LSS 9§8 Bostad barn och ungdomar 2026.docx',
        tenderingID: 1606,
        hideFromSupplier: true
      },
      {
        fileName: 'Ramavtal och krav på tjänsten LSS 9§8 Bostad barn och ungdomar 2026',
        url: '/assets/1606/Ramavtal och krav på tjänsten LSS 9§8 Bostad barn och ungdomar 2026.pdf',
        tenderingID: 1606
      },
      {
        fileName: 'Upphandlingsdokument LSS 9§8 Bostad barn och ungdomar 2026',
        url: '/assets/1606/Upphandlingsdokument LSS 9§8 Bostad barn och ungdomar 2026.pdf',
        tenderingID: 1606,
      },
      {
        fileName: 'Placeringsavtal LSS 9§10 Daglig verksamhet 2026',
        url: '/assets/1616/Placeringsavtal LSS 9§10 Daglig verksamhet 2026.docx',
        tenderingID: 1616,
        isPlacementFile: true
      },
      {
        fileName: 'Information om nytt ramavtal; LSS 9§10 Daglig verksamhet 2026',
        url: '/assets/1616/Information om nytt ramavtal; LSS 9§10 Daglig verksamhet 2026 (1).pdf',
        tenderingID: 1616
      },
      {
        fileName: 'Ramavtal och krav på tjänsten LSS 9§10 Daglig verksamhet 2026',
        url: '/assets/1616/Ramavtal och krav på tjänsten LSS 9§10 Daglig verksamhet 2026.pdf',
        tenderingID: 1616
      },
      {
        fileName: 'Upphandlingsdokument LSS 9§10 Daglig verksamhet 2026',
        url: '/assets/1616/Upphandlingsdokument LSS 9§10 Daglig verksamhet 2026.pdf',
        tenderingID: 1616
      },
      {
        fileName: 'Utanför ram placeringsavtal LSS 9§10 Daglig verksamhet 2026',
        url: '/assets/1616/Utanför ram placeringsavtal LSS 9§10 Daglig verksamhet 2026.docx',
        tenderingID: 1616,
        hideFromSupplier: true
      },
      {
        fileName: 'Placeringsavtal HVB Barn och unga 2026',
        url: '/assets/2606/Placeringsavtal HVB Barn och unga 2026.docx',
        tenderingID: 2606,
        isPlacementFile: true
      },
      {
        fileName: 'Mall månadsrapport HVB Barn och unga 2026',
        url: '/assets/2606/Mall månadsrapport HVB Barn och unga 2026.docx',
        tenderingID: 2606
      },
      {
        fileName: 'Ramavtal och krav på tjänst HVB barn och unga 2026, Skåne, Halland, Kronoberg',
        url: '/assets/2606/Ramavtal och krav på tjänst HVB barn och unga 2026, Skåne, Halland, Kronoberg.pdf',
        tenderingID: 2606
      },
      {
        fileName: 'Upphandlingsdokument HVB barn och unga 2026, Skåne, Halland, Kronoberg',
        url: '/assets/2606/Upphandlingsdokument HVB barn och unga 2026, Skåne, Halland, Kronoberg.pdf',
        tenderingID: 2606
      }
    ];


export default files;